import { render, staticRenderFns } from "./JobDetailWrapper.vue?vue&type=template&id=2a550f19&"
import script from "./JobDetailWrapper.vue?vue&type=script&lang=js&"
export * from "./JobDetailWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailWrapper.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports